import { useSnackbar } from 'notistack'
import { SnackbarContent, type CustomContentProps } from 'notistack'
import { forwardRef } from 'react'
import { FeedbackMessageContent } from './FeedbackMessageContent.tsx'
import { styled } from "@mui/system";

export interface ActionProps {
  onClick: () => void
  label: string
}

export interface SnackbarNotificationProps extends CustomContentProps {
  message: string
  title?: string
  mainActionButton?: ActionProps
  secondaryActionButton?: ActionProps
  actionLink?: ActionProps
}

const StyledSnackbarContent = styled(SnackbarContent)(() => ({
  maxWidth: '400px',
  boxShadow: `1px 4px 12px rgba(0, 0, 0, 0.09)`
}))

export const SnackbarNotification = forwardRef<HTMLDivElement, SnackbarNotificationProps>(
  ({ id, variant, ...props }, ref) => {
    const { closeSnackbar } = useSnackbar()

    return (
      <StyledSnackbarContent ref={ref} {...props}>
        <FeedbackMessageContent
          variant={variant}
          title={props.title}
          message={props.message}
          mainActionButton={props.mainActionButton}
          secondaryActionButton={props.secondaryActionButton}
          actionLink={props.actionLink}
          onClose={() => closeSnackbar(id)}
        />
      </StyledSnackbarContent>
    )
  }
)